import type { EnemyId } from "./enemies";
import type { SpriteName } from "./sprites";

export const ENEMY_SPRITES: Record<EnemyId, SpriteName> = {
  "dire-rat": "direRat",
  "soldier-ant": "soldierAnt",
  "sewer-toad": "sewerToad",
  "abyssal-squid": "abyssalSquid",
  "abyssal-ooze": "abyssalOoze",
  alligator: "alligator",
  ant: "ant",
  "beast-tamer": "beastTamer",
  bee: "bee",
  "basalt-wyrm": "basaltWyrm",
  "cave-bat": "caveBat",
  "clay-golem": "clayGolem",
  dragonfly: "dragonfly",
  "fire-ant": "fireAnt",
  "fire-alligator": "fireAlligator",
  "glow-scorpion": "glowScorpion",
  "gloom-wisp": "gloomWisp",
  goblin: "goblin",
  "goblin-archer": "goblinArcher",
  "goblin-chief": "goblinChief",
  "goblin-shaman": "goblinShaman",
  merman: "merman",
  mimic: "mimic",
  octopus: "octopus",
  "ooze-guardian": "oozeGuardian",
  "ore-beetle": "oreBeetle",
  rat: "rat",
  "squid-knight": "squidKnight",
  "squid-tentacle": "squidTentacle",
  skeleton: "skeleton",
  "skeleton-brachiosaurus": "skeletonBrachiosaurus",
  "skeleton-giraffe": "skeletonGiraffe",
  "skeleton-hippo": "skeletonHippo",
  "skeleton-king": "skeletonKing",
  "skeleton-prince": "skeletonPrince",
  "skeleton-rhino": "skeletonRhino",
  spider: "spider",
  undertaker: "undertaker",
  forgeling: "forgeling",
  "chain-forgeling": "chainForgeling",
  "bellows-forgeling": "bellowsForgeling",
  "hammer-forgeling": "hammerForgeling",
  "rustmire-engine": "rustmireEngine",
  "brine-dynamo": "brineDynamo",
  "barnacle-drone": "barnacleDrone",
  mummy: "mummy",
  "coconut-bailiff": "coconutBailiff",
  "reef-auditor": "reefAuditor",
  "vacation-emperor": "vacationEmperor",
};

export function enemySprite(definitionId: string): SpriteName {
  const sprite = ENEMY_SPRITES[definitionId as EnemyId];
  if (!sprite) {
    throw new Error(`Missing enemy sprite mapping for ${definitionId}.`);
  }
  return sprite;
}
